import React from "react";

/* ── Asset imports ── */
import HeroBgImg         from "../../asset/images/news/UnderstandingESPHero-bg.webp";
import ArticleImg        from "../../asset/images/news/article-16.webp";
import YoutubeIcon       from "../../asset/images/news/icon-youtube.svg";
import LinkedinIcon      from "../../asset/images/news/icon-linkedin.svg";
import BcSepIcon         from "../../asset/images/news/breadcrumb-separator.svg";
import ProfileIcon       from "../../asset/images/news/icon-profile.svg";
import CalendarIcon      from "../../asset/images/news/icon-calendar.svg";
import ClockIconImg      from "../../asset/images/news/icon-clock.svg";
import CommentsIcon      from "../../asset/images/news/icon-comments.svg";
import PreviousIcon      from "../../asset/images/news/icon-previous.svg";
import NextIcon          from "../../asset/images/news/icon-next.svg";
import FacebookIcon      from "../../asset/images/news/icon-facebook.svg";
import TwitterIcon       from "../../asset/images/news/icon-twitter.svg";
import LinkedinShareIcon from "../../asset/images/news/icon-linkedin-share.svg";

/* ── Recent post thumbnails ── */
import RecentImg1 from "../../asset/images/news/news-1.webp";
import RecentImg2 from "../../asset/images/news/news-2.webp";
import RecentImg3 from "../../asset/images/news/news-3.webp";
import RecentImg4 from "../../asset/images/news/news-4.webp";

const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700;800&display=swap');

  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
  .uep { font-family: 'Poppins', sans-serif; font-size: 14px; color: #202020; background: #fff; }

  /* ══ HERO ══ */
  .uep-hero {
    position: relative; width: 100%; height: 460px;
    overflow: hidden; 
  }
  .uep-hero-bg {
    position: absolute; inset: 0;
    width: 100%; height: 100%;
    object-fit: cover; object-position: center right; display: block;
  }
  .uep-hero-overlay {
    position: absolute; inset: 0;
    // background: linear-gradient(
    //   to right,
    //   rgba(0,0,0,0.85) 0%,
    //   rgba(0,0,0,0.65) 38%,
    //   rgba(0,0,0,0.10) 100%
    // );
  }
  .uep-hero-content {
    position: absolute; inset: 0;
    display: flex; flex-direction: column; justify-content: center;
    padding: 0 102px;
    max-width: 1600px; margin: 0 auto; left: 0; right: 0;
  }
  .uep-hero-title {
    font-family: 'Poppins', sans-serif;
    font-size: 42px; font-weight: 600; color: #fff;
    line-height: 120%; margin-bottom: 15px; max-width: 520px;
  }
  .uep-hero-divider {
    width: 479px; height: 2px;
    background: #EB2019; border: none; margin-bottom: 15px;
  }
  .uep-hero-subtitle {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #fff;
    line-height: 160%; max-width: 479px;
  }

  /* ══ BREADCRUMB ══ */
  .uep-breadcrumb { width: 100%; padding: 40px 0 0 0; }
  .uep-breadcrumb-inner {
    max-width: 1600px; margin: 0 auto; padding: 0 102px;
    display: flex; align-items: center; flex-wrap: wrap;
  }
  .uep-bc-item {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 500; color: #202020;
    text-decoration: none; display: flex; align-items: center; gap: 14px;
    transition: color 0.15s;
  }
  .uep-bc-item:hover { color: #EB2019; }
  .uep-bc-sep {
    display: flex; align-items: center; justify-content: center;
    width: 24px; height: 24px; border-radius: 50%;
    margin: 0 8px; flex-shrink: 0;
  }
  .uep-bc-sep img { width: 24px; height: 24px; display: block; }
  .uep-bc-item.active { color: #202020; font-weight: 500; }

  /* ══ INNER ══ */
  .uep-inner { max-width: 1600px; margin: 0 auto; padding: 0 102px; }

  /* ══ MAIN ══ */
  .uep-main-section { padding: 80px 0 120px 0; }
  .uep-main-row { display: flex; align-items: flex-start; gap: 89px; }

  /* ══ ARTICLE ══ */
  .uep-article { flex: 1; min-width: 0; }

  .uep-meta-bar {
    display: flex; align-items: center; flex-wrap: wrap; gap: 20px;
    margin-bottom: 30px;
  }
  .uep-meta-item {
    display: flex; align-items: center; gap: 8px;
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #202020;
    border-right: 1px solid #7A7A7A; padding-right: 15px;
  }
  .uep-meta-item:last-child { border-right: none; padding-right: 0; }
  .uep-meta-item img { width: 24px; height: 24px; display: block; flex-shrink: 0; }

  .uep-article-title {
    font-family: 'Poppins', sans-serif;
    font-size: 32px; font-weight: 600; color: #202020;
    line-height: 140%; margin-bottom: 30px;
  }

  .uep-article-img {
    width: 100%; height: 450px;
    object-fit: cover; border-radius: 10px;
    display: block; margin: 45px 0 30px 0;
  }

  .uep-article-body {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #202020;
    line-height: 160%;
  }
  .uep-article-body p { margin-bottom: 20px; }
  .uep-article-body p:last-child { margin-bottom: 0; }

  .uep-h2 {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 600; color: #202020;
    margin: 30px 0 15px 0; line-height: 160%; display: block;
  }

  /* Numbered sub-heading bold */
  .uep-h3 {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 600; color: #202020;
    margin: 20px 0 10px 0; line-height: 160%; display: block;
  }

  .uep-article-body strong { font-weight: 600; color: #202020; }

  .uep-red-link { color: #EB2019; text-decoration: underline; font-weight: 600; }
  .uep-red-link:hover { opacity: 0.8; }

  /* ══ BOTTOM ROW ══ */
  .uep-bottom-row {
    display: flex; align-items: center; justify-content: space-between;
    margin-top: 30px; padding-top: 30px;
    border-top: 1px solid #C7C7C7; flex-wrap: wrap; gap: 16px;
  }
  .uep-bottom-nav { display: flex; align-items: center; gap: 60px; }
  .uep-nav-btn {
    display: inline-flex; align-items: center; gap: 20px;
    font-family: 'Poppins', sans-serif;
    font-size: 20px; font-weight: 500; color: #202020;
    text-decoration: none; background: none; border: none;
    cursor: pointer; transition: color 0.15s;
  }
  .uep-nav-btn:hover { color: #EB2019; }
  .uep-nav-btn img { width: 40px; height: 40px; display: block; }

  .uep-share-icons { display: flex; align-items: center; gap: 20px; }
  .uep-share-icon {
    display: flex; align-items: center; justify-content: center;
    width: 40px; height: 40px; border-radius: 50%;
    text-decoration: none; flex-shrink: 0; transition: opacity 0.15s;
  }
  .uep-share-icon:hover { opacity: 0.85; }
  .uep-share-icon img { width: 44px; height: 44px; display: block; }

  /* ══ SIDEBAR ══ */
  .uep-sidebar { flex: 0 0 475px; }
  .uep-sidebar-block { margin-bottom: 60px; }
  .uep-sidebar-title {
    font-family: 'Poppins', sans-serif;
    font-size: 24px; font-weight: 600; color: #202020;
    margin-bottom: 30px; padding-bottom: 20px;
    border-bottom: 1px solid #EB2019; line-height: 120%;
  }
  .uep-recent-list { display: flex; flex-direction: column; gap: 30px; }
  .uep-recent-item {
    display: flex; align-items: flex-start; gap: 12px;
    text-decoration: none; color: #202020;
  }
  .uep-recent-item:hover .uep-recent-title { color: #EB2019; }
  .uep-recent-img {
    flex: 0 0 200px; height: 120px;
    object-fit: cover; border-radius: 6px; display: block;
  }
  .uep-recent-body { flex: 1; min-width: 0; }
  .uep-recent-title {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #202020;
    line-height: 160%; transition: color 0.15s;
    display: -webkit-box; -webkit-line-clamp: 3;
    -webkit-box-orient: vertical; overflow: hidden;
  }
  .uep-social-icons { display: flex; align-items: center; gap: 30px; }
  .uep-social-icon {
    display: flex; align-items: center; justify-content: center;
    width: 40px; height: 40px; border-radius: 6px; overflow: hidden;
    text-decoration: none; transition: opacity 0.15s;
  }
  .uep-social-icon:hover { opacity: 0.8; }
  .uep-social-icon img { width: 44px; height: 44px; object-fit: contain; display: block; }

  /* ══ RESPONSIVE — TABLET ══ */
  @media (max-width: 768px) {
    .uep-hero             { height: 350px; }
    .uep-hero-content     { padding: 0 32px; }
    .uep-hero-title       { font-size: 30px; }
    .uep-hero-divider     { width: 100%; max-width: 479px; }
    .uep-breadcrumb       { padding: 24px 0 0 0; }
    .uep-breadcrumb-inner { padding: 0 32px; }
    .uep-inner            { padding: 0 32px; }
    .uep-main-section     { padding: 48px 0 60px 0; }
    .uep-main-row         { flex-direction: column; gap: 48px; }
    .uep-sidebar          { flex: none; width: 100%; }
    .uep-article-title    { font-size: 20px; }
  }

  /* ══ RESPONSIVE — MOBILE ══ */
  @media (max-width: 480px) {
    .uep-hero             { height: 360px; }
    .uep-hero-content     { padding: 0 16px; }
    .uep-hero-title       { font-size: 24px; margin-bottom: 15px; }
    .uep-hero-divider     { width: 100%; }
    .uep-hero-subtitle    { font-size: 14px; }
    .uep-breadcrumb       { padding: 30px 0 0 0; }
    .uep-breadcrumb-inner { padding: 0 16px; }
    .uep-bc-item          { font-size: 14px; gap: 14px; }
    .uep-bc-sep           { width: 18px; height: 18px; margin: 0 4px; }
    .uep-bc-sep img       { width: 22px; height: 22px; }
    .uep-inner            { padding: 0 16px; }
    .uep-main-section     { padding: 30px 0 60px 0; }
    .uep-main-row         { flex-direction: column; gap: 60px; }
    .uep-sidebar          { flex: none; width: 100%; }
    .uep-article-title    { font-size: 20px; margin-bottom: 15px; }
    .uep-article-body     { font-size: 14px; }
    .uep-article-body p   { margin-bottom: 15px; }
    .uep-meta-item        { font-size: 14px; }
    .uep-article-img      { margin: 30px 0 15px 0; height: 250px; }
    .uep-h2               { font-size: 16px; margin: 30px 0 15px 0; }
    .uep-h3               { font-size: 14px; margin: 15px 0 10px 0; }
    .uep-nav-btn img      { width: 24px; height: 24px; }
    .uep-nav-btn          { font-size: 14px; }
    .uep-share-icon img   { width: 34px; height: 34px; }
  }
`;

const recentPosts = [
  {
    img: RecentImg1,
    title: "Battery Formation & Testing: Enabling The Rise Of EV & Energy Storage Manufacturing",
    slug: "battery-formation-testing-enabling-rise-ev-energy-storage-manufacturing",
  },
  {
    img: RecentImg2,
    title: "Next-Gen ESP Power Supplies: Upgrades and Sustainability in Industrial Air Pollution Control",
    slug: "next-gen-esp-power-supplies-upgrades-sustainability-industrial-air-pollution-control",
  },
  {
    img: RecentImg3,
    title: "Green Hydrogen Power Electronics: Ador Powertron at the Forefront of Electrolyzer Rectifier Setups",
    slug: "green-hydrogen-power-electronics-ador-powertron-forefront-electrolyzer-rectifier-setups",
  },
  {
    img: RecentImg4,
    title: "Transformer Bushings: Types & Importance",
    slug: "transformer-bushings-types-importance",
  },
];

export default function UnderstandingElectrostaticPrecipitators() {
  return (
    <div className="uep">
      <style>{CSS}</style>

      {/* ══ HERO ══ */}
      <section className="uep-hero">
        <img className="uep-hero-bg" src={HeroBgImg} alt="Understanding ESP Hero" />
        <div className="uep-hero-overlay" />
        <div className="uep-hero-content">
          <h1 className="uep-hero-title">
            Understanding Electrostatic Precipitators: A Comprehensive Guide
          </h1>
          <hr className="uep-hero-divider" />
          <p className="uep-hero-subtitle">
            Everything we do is designed, whether we're producing a magazine, a website, or a bridge. Design is really the creative invention that designs everything.
          </p>
        </div>
      </section>

      {/* ══ BREADCRUMB ══ */}
      <nav className="uep-breadcrumb" aria-label="Breadcrumb">
        <div className="uep-breadcrumb-inner">
          <a href="/" className="uep-bc-item">Home</a>
          <span className="uep-bc-sep"><img src={BcSepIcon} alt="" /></span>
          <a href="/news" className="uep-bc-item">News &amp; Updates</a>
          <span className="uep-bc-sep"><img src={BcSepIcon} alt="" /></span>
          <span className="uep-bc-item active">Post</span>
        </div>
      </nav>

      {/* ══ MAIN ══ */}
      <section className="uep-main-section">
        <div className="uep-inner">
          <div className="uep-main-row">

            {/* ── ARTICLE ── */}
            <article className="uep-article">

              {/* Meta bar */}
              <div className="uep-meta-bar">
                <span className="uep-meta-item"><img src={ProfileIcon} alt="author" /> Admin</span>
                <span className="uep-meta-item"><img src={CalendarIcon} alt="date" /> April 28, 2025</span>
                <span className="uep-meta-item"><img src={ClockIconImg} alt="time" /> 10:14 am</span>
                <span className="uep-meta-item"><img src={CommentsIcon} alt="comments" /> No Comments</span>
              </div>

              {/* Title */}
              <h1 className="uep-article-title">
                Understanding Electrostatic Precipitators: A Comprehensive Guide
              </h1>

              {/* Body */}
              <div className="uep-article-body">

                <span className="uep-h2">What Are Electrostatic Precipitators?</span>

                <p><a href="/electrostatic-precipitators" className="uep-red-link">Electrostatic precipitators</a> are devices used to remove solid particles, such as dust and smoke, from gases in industrial processes. They work by applying high voltage to charged plates or wires, which attract particles from the gas stream and effectively trap them. The particles then fall to the bottom of the precipitator, where they can be collected and disposed of.<br />
                This technology is widely used in power plants, cement factories, steel mills, and chemical plants, where large volumes of dust and particulate matter are generated as a byproduct of industrial processes.<br />
                Electrostatic precipitators (ESPs) are crucial for controlling air pollution, especially in industrial settings. These devices efficiently remove particles from a gas stream using electrostatic forces, contributing to cleaner air and better environmental standards. This article will explore the working principle, types, applications, benefits, and future developments of electrostatic precipitators, providing you with a comprehensive understanding of this vital air filtration technology.</p>

                {/* Article image */}
                <img className="uep-article-img" src={ArticleImg} alt="Electrostatic Precipitator" />

                <span className="uep-h2">Key Factors Influencing Electrostatic Precipitators Performance</span>

                <p>The efficiency of an electrostatic precipitator is influenced by several critical factors, including particle resistivity, gas flow rate, and the design of the collection system. Particles with normal resistivity (ranging between 10⁷ and 2 x 10⁶ ohm-cm) are ideal, as they maintain their charge long enough to be effectively captured by the collection plates. Conversely, particles with very high or very low resistivity can pose challenges: high-resistivity particles may lead to back corona discharge, reducing collection efficiency, while low-resistivity particles may not adhere well to the plates, leading to re-entrainment in the gas stream.</p>

                <span className="uep-h2">Advancements in Electrostatic Precipitators Technology</span>

                <p>Modern <a href="/electrostatic-precipitators" className="uep-red-link">Electrostatic Precipitators</a> have evolved significantly, incorporating advanced features to enhance performance and reliability. Innovations such as automatic voltage control systems help maintain optimal electric field strength, minimizing sparking and preventing arcing. Additionally, the development of rigid discharge electrodes with sharpened spikes has improved corona generation, leading to more effective particle charging and collection. These technological advancements contribute to higher collection efficiencies and reduced maintenance requirements.</p>

                <span className="uep-h2">Environmental and Economic Benefits</span>

                <p>Implementing ESPs in industrial settings offers substantial environmental and economic advantages. By removing over 99% of particulate matter from flue gases, ESPs significantly reduce air pollution, helping industries comply with stringent environmental regulations. Economically, ESPs contribute to operational efficiency by preventing the accumulation of particulate deposits on equipment, thereby reducing maintenance costs and prolonging the lifespan of machinery.</p>

                <span className="uep-h2">Future Outlook and Sustainability</span>

                <p>As industries continue to prioritize sustainability, the role of ESPs is becoming increasingly vital. Ongoing research focuses on enhancing ESP performance through the integration of smart monitoring systems and adaptive control technologies. These advancements aim to optimize energy consumption and adapt to varying operational conditions in real-time. Furthermore, the development of hybrid systems combining ESPs with other filtration technologies is being explored to tackle a broader range of pollutants, aligning with global efforts to achieve cleaner and more sustainable industrial processes.</p>

                <span className="uep-h2">How Do Electrostatic Precipitators Work?</span>

                <p>The working principle of electrostatic precipitators is based on the concept of electrostatic charges. The process typically involves three main stages:</p>

                <p><strong>1. Charging of Particles:</strong> The gas stream containing particles passes through an ionizing field, giving the particles a negative or positive charge. This is typically achieved by passing the particles through ionizing electrodes that emit electrons.<br />
                <strong>2. Collection of Particles:</strong> Once the particles are charged, they are attracted to oppositely charged plates or electrodes in the precipitator. The particles adhere to these plates due to the electrostatic forces.<br />
                <strong>3. Discharge and Removal:</strong> Over time, particles accumulate on the collection plates. These plates can be cleaned by periodic discharges or mechanical methods, and the accumulated dust is collected and disposed of appropriately.</p>

                <p>This process allows electrostatic precipitators to effectively filter out particles as small as 0.1 microns, making them a highly efficient method for controlling air pollution.</p>

                <span className="uep-h2">Types of Electrostatic Precipitators</span>

                <p>There are several types of electrostatic precipitators, each designed for specific applications. The most common types include:</p>

                <span className="uep-h3">1. Wet Electrostatic Precipitators (WESP)</span>
                <p>Wet electrostatic precipitators are primarily used for applications involving sticky or wet particles. These precipitators use a water spray to help capture and remove the particles, making them ideal for industries dealing with high moisture content in their emissions. Wet ESPs are particularly effective at removing fine particles, aerosols, and liquid droplets.</p>

                <span className="uep-h3">2. Dry Electrostatic Precipitators (DESP)</span>
                <p>Dry electrostatic precipitators are the most commonly used type. They capture dry particles like dust, smoke, and soot from industrial emissions. The dust is collected on electrically charged plates and removed via periodic mechanical cleaning.</p>

                <span className="uep-h3">3. Reverse-Current Electrostatic Precipitators</span>
                <p>In this type, the polarity of the electrical charge is periodically reversed to help dislodge collected particles from the electrodes. This method enhances dust removal efficiency and reduces the need for manual cleaning.</p>

                <span className="uep-h2">Advantages of Using Electrostatic Precipitators</span>

                <p>Electrostatic precipitators offer a range of benefits, making them a popular choice for industries seeking to reduce air pollution:</p>

                <span className="uep-h3">1. High Efficiency</span>
                <p>One of the most significant advantages of ESPs is their efficiency. Depending on the design and operating conditions, these systems can capture up to 99% of particulate matter from gas streams. They effectively remove large and fine particles, even as small as 0.1 microns.</p>

                <span className="uep-h3">2. Low Operating Costs</span>
                <p>Compared to other air filtration methods, electrostatic precipitators are relatively cost-effective. They require minimal maintenance and consume less power, making them a sustainable solution for long-term pollution control.</p>

                <span className="uep-h3">3. Environmental Impact</span>
                <p>Electrostatic precipitators (ESPs) significantly reduce air pollution. By removing harmful particles such as dust, soot, and smoke from industrial emissions, ESPs help industries comply with environmental regulations and improve air quality.</p>

                <span className="uep-h3">4. Waste Incineration</span>
                <p>Incineration processes, especially in waste-to-energy plants, produce high levels of smoke and particulate emissions. Electrostatic precipitators help reduce these emissions by efficiently capturing particles from the exhaust gases.</p>

                <span className="uep-h2">Challenges and Limitations of Electrostatic Precipitators</span>

                <p>While electrostatic precipitators are highly effective, they do have some limitations and challenges:</p>

                <span className="uep-h3">1. High Initial Cost</span>
                <p>Installing electrostatic precipitators can be expensive due to the complexity of the system and the materials required. However, the long-term operational savings can offset the initial investment.</p>

                <span className="uep-h3">2. Limited Efficiency for Gaseous Pollutants</span>
                <p>ESPs are highly effective at capturing particulate matter but not as effective at removing gaseous pollutants, such as carbon dioxide or volatile organic compounds (VOCs). In some cases, additional filtration technologies may be required.</p>

                <span className="uep-h3">3. Maintenance Requirements</span>
                <p>While ESPs generally require little maintenance, periodic cleaning and inspection are necessary to ensure continued efficiency. Over time, the collection plates can become clogged, reducing the system's effectiveness.</p>

                <span className="uep-h2">The Future of Electrostatic Precipitators</span>

                <p>The future of electrostatic precipitators looks promising, with technological advancements making them more efficient and versatile. Some of the developments to watch out for include:</p>

                <span className="uep-h3">1. Integration with Other Pollution Control Technologies</span>
                <p>As industries move towards more sustainable practices, ESPs will likely be integrated with other technologies, such as scrubbers or filters, to provide more comprehensive pollution control solutions.</p>

                <span className="uep-h3">2. Smart Electrostatic Precipitators</span>
                <p>Integrating innovative technologies like sensors and IoT devices can help monitor and optimize electrostatic precipitator performance in real time. This will allow industries to improve efficiency, reduce maintenance costs, and enhance overall system performance.</p>

                <span className="uep-h3">3. Improved Materials and Designs</span>
                <p>Advancements in materials science may lead to the development of more durable and efficient collection plates, which will enhance the performance of ESPs and reduce maintenance requirements.</p>

                <span className="uep-h2">Frequently Asked Questions (FAQs)</span>

                <p><strong>Q1: How does particle resistivity affect ESP performance?</strong><br />
                A: High-resistivity particles may not release their charge easily, making them harder to collect. Gas conditioning can help.</p>

                <p><strong>Q2: Can ESPs be used for oily or sticky particles?</strong><br />
                A: Wet ESPs are best suited for sticky particles. Dry ESPs may struggle with such materials.</p>

                <p><strong>Q3: What is the typical lifespan of an ESP?</strong><br />
                A: With proper maintenance, ESPs can last 15–25 years or more.</p>

                <span className="uep-h2">Conclusion</span>

                <p>Electrostatic precipitators are an essential technology for controlling particulate emissions in industrial settings. They offer high efficiency, low operating costs, and significant environmental benefits. Despite some limitations, such as high initial costs and the need for periodic maintenance, the benefits of ESPs far outweigh the drawbacks. As technology evolves, electrostatic precipitators will play an even more significant role in reducing air pollution and improving environmental sustainability.<br />
                By understanding how electrostatic precipitators work, their advantages, and their applications, industries can make informed decisions about pollution control strategies and contribute to cleaner air for all.</p>

                <p><a href="/contact" className="uep-red-link">Contact our team</a> for expert advice and solutions if you want to learn more about electrostatic precipitators or how they can help your industry meet environmental regulations.</p>

                <p><a href="/esp-technologies" className="uep-red-link">Adopt the latest ESP technologies to stay ahead in air pollution control.</a></p>

              </div>

              {/* ── Bottom row ── */}
              <div className="uep-bottom-row">
                <div className="uep-bottom-nav">
                  <a href="/news/previous" className="uep-nav-btn">
                    <img src={PreviousIcon} alt="Previous" />
                    Previous
                  </a>
                  <a href="/news/next" className="uep-nav-btn">
                    Next
                    <img src={NextIcon} alt="Next" />
                  </a>
                </div>
                <div className="uep-share-icons">
                  <a href="#" className="uep-share-icon" aria-label="Facebook">
                    <img src={FacebookIcon} alt="Facebook" />
                  </a>
                  <a href="#" className="uep-share-icon" aria-label="Twitter">
                    <img src={TwitterIcon} alt="Twitter" />
                  </a>
                  <a href="#" className="uep-share-icon" aria-label="LinkedIn">
                    <img src={LinkedinShareIcon} alt="LinkedIn" />
                  </a>
                </div>
              </div>

            </article>

            {/* ── SIDEBAR ── */}
            <aside className="uep-sidebar">

              {/* Recent Posts */}
              <div className="uep-sidebar-block">
                <p className="uep-sidebar-title">Recent Posts</p>
                <div className="uep-recent-list">
                  {recentPosts.map((post, idx) => (
                    <a key={idx} href={`/news/${post.slug}`} className="uep-recent-item">
                      <img src={post.img} alt={post.title} className="uep-recent-img" />
                      <div className="uep-recent-body">
                        <span className="uep-recent-title">{post.title}</span>
                      </div>
                    </a>
                  ))}
                </div>
              </div>

              {/* Social Media */}
              <div className="uep-sidebar-block">
                <p className="uep-sidebar-title">Social Media</p>
                <div className="uep-social-icons">
                  <a href="#" className="uep-social-icon" aria-label="YouTube">
                    <img src={YoutubeIcon} alt="YouTube" />
                  </a>
                  <a href="#" className="uep-social-icon" aria-label="LinkedIn">
                    <img src={LinkedinIcon} alt="LinkedIn" />
                  </a>
                </div>
              </div>

            </aside>

          </div>
        </div>
      </section>

    </div>
  );
}